var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "teacherLayoutRootBox" }, [
    _c("div", { staticClass: "header" }, [
      _c("div", { staticClass: "title" }, [_vm._v("数据统计")]),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("m-selects", {
            on: {
              change: _vm.selectChange,
              courseChange: function() {
                return _vm.courseTabChange(1)
              }
            }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "main" }, [
      _c("div", { attrs: { role: "aphorism" } }, [_c("m-aphorism")], 1),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { role: "openingStatus" } },
        [
          _c("m-opening-status", {
            attrs: {
              "left-list": _vm.openingStatus,
              ranking: _vm.ranking,
              "hide-right": true
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { "data-title": "专业人数", role: "numberOfProfessionals" } },
        [
          _c("m-title", {
            attrs: { "title-text": "专业人数", "tip-text": _vm.tipText }
          }),
          _vm._v(" "),
          _c("m-course-tab", {
            attrs: { "current-type": _vm.courseType },
            on: {
              change: function(type) {
                return _vm.courseTabChange(type, true)
              }
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { flex: "1", width: "100%" } },
            [
              _c("m-chart", {
                attrs: { "option-data": _vm.numberOfProfessionalsBarData }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { "data-title": "选课量排行", role: "studentRanking" } },
        [
          _c("m-ranking-list", {
            staticStyle: { "margin-top": "30px" },
            attrs: {
              "min-titles": { column3Name: "选课量" },
              "ranking-list": _vm.learningRanking,
              total: _vm.learningRanking.total
            },
            on: { pageChange: _vm.getLearningRanking }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { "data-title": "学习时长", role: "learningDuration" } },
        [
          _c("m-title", {
            attrs: {
              "title-text": "学习时长",
              "tip-text": _vm.tipText + "，显示从当前时间往前一周或一个月的数据"
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "learningDuration" },
            [
              _c("m-chart", {
                attrs: {
                  "option-data": _vm.learningDurationBrokenLineData,
                  "tip-style": _vm.tipStyle
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "timeSwitchBox" },
            [_c("m-switch", { on: { change: _vm.timeSwitchChange } })],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { "data-title": "", role: "creditHourRanking" } },
        [
          _c("m-title", {
            attrs: {
              "title-text": "学时排行",
              "tip-text":
                "该模块统计数字课程、实践教学的学习时长及讨论笔记等教学工具的使用时长"
            }
          }),
          _vm._v(" "),
          _c("m-ranking-list", {
            staticStyle: { "margin-top": "30px" },
            attrs: {
              "ranking-list": _vm.creditHourRanking,
              total: _vm.creditHourRanking.total,
              "is-date": true
            },
            on: { pageChange: _vm.findPage }
          })
        ],
        1
      ),
      _vm._v(" "),
      false
        ? _c(
            "div",
            {
              attrs: { "data-title": "课程进度和排行", role: "courseProgress" }
            },
            [
              _c("m-line-progress", {
                attrs: {
                  progress:
                    _vm.classProgress[_vm.rankingProgressTag.courseProgress],
                  progressClass: "blue"
                }
              }),
              _vm._v(" "),
              _c(
                "m-ranking-list",
                {
                  staticStyle: { flex: "1" },
                  attrs: {
                    "min-titles": { column3Name: "进度" },
                    "ranking-list":
                      _vm.classProgressList[
                        _vm.rankingProgressTag.courseProgress
                      ],
                    total:
                      _vm.classProgressList[
                        _vm.rankingProgressTag.courseProgress
                      ].total
                  },
                  on: {
                    pageChange: function(pageNum) {
                      return _vm.getClassProgressList("", pageNum, false)
                    }
                  }
                },
                [_vm._v("\n        >\n      ")]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      false
        ? _c(
            "div",
            {
              attrs: {
                "data-title": "课程实践练习进度和排行",
                role: "exerciseProgress"
              }
            },
            [
              _c("m-line-progress", {
                attrs: {
                  progress:
                    _vm.classProgress[_vm.rankingProgressTag.exerciseProgress],
                  progressClass: "green"
                }
              }),
              _vm._v(" "),
              _c("m-ranking-list", {
                staticStyle: { flex: "1" },
                attrs: {
                  "min-titles": { column3Name: "进度" },
                  "ranking-list":
                    _vm.classProgressList[
                      _vm.rankingProgressTag.exerciseProgress
                    ],
                  total:
                    _vm.classProgressList[
                      _vm.rankingProgressTag.exerciseProgress
                    ].total
                },
                on: {
                  pageChange: function(pageNum) {
                    return _vm.getClassProgressList(
                      _vm.rankingProgressTag.exerciseProgress,
                      pageNum,
                      false
                    )
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      false
        ? _c(
            "div",
            {
              attrs: {
                "data-title": "实践教学进度和排行",
                role: "teachingProgress"
              }
            },
            [
              _c("m-line-progress", {
                attrs: {
                  progress:
                    _vm.classProgress[_vm.rankingProgressTag.teachingProgress],
                  progressClass: "yellow"
                }
              }),
              _vm._v(" "),
              _c("m-ranking-list", {
                staticStyle: { flex: "1" },
                attrs: {
                  "min-titles": { column3Name: "进度" },
                  "ranking-list":
                    _vm.classProgressList[
                      _vm.rankingProgressTag.teachingProgress
                    ],
                  total:
                    _vm.classProgressList[
                      _vm.rankingProgressTag.teachingProgress
                    ].total
                },
                on: {
                  pageChange: function(pageNum) {
                    return _vm.getClassProgressList(
                      _vm.rankingProgressTag.teachingProgress,
                      pageNum,
                      false
                    )
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { "data-title": "测验进度", role: "testProgress" } },
        [
          _c("m-line-progress", {
            staticStyle: { "margin-bottom": "50px" },
            attrs: { progress: _vm.testProgress, progressClass: "yellow" }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "cProgressBox" },
            [_c("m-circular-progress", { attrs: { score: _vm.testScore } })],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { "data-title": "", role: "testScore" } },
        [
          _c("m-title", {
            attrs: { "title-text": "测验分数", "tip-text": _vm.testTipText }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "learningDuration" },
            [
              _c("m-chart", {
                attrs: { "option-data": _vm.testScoreBrokenLineData }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { "data-title": "笔记和讨论", role: "notesAndDiscussions" } },
        [
          _c(
            "div",
            { staticStyle: { height: "55%", width: "80%" } },
            [
              _c("m-notes-and-discussions", {
                attrs: { "data-list": _vm.notesAndDiscusCounts }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { "data-title": "笔记榜", role: "notebookList" } },
        [
          _c("m-ranking-list", {
            staticStyle: { flex: "1" },
            attrs: {
              "min-titles": { column3Name: "笔记条数" },
              "ranking-list": _vm.noteCountSort,
              total: _vm.noteCountSort.total
            },
            on: { pageChange: _vm.getNoteCountSort }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { "data-title": "讨论榜", role: "discussionBoard" } },
        [
          _c("m-ranking-list", {
            staticStyle: { flex: "1" },
            attrs: {
              "min-titles": { column3Name: "讨论条数" },
              "ranking-list": _vm.discussCountSort,
              total: _vm.discussCountSort.total
            },
            on: { pageChange: _vm.getDiscussCountSort }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-11d97fd8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11d97fd8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/szrt_revision/new_account_settings/accountSettings/overallStatistics/layout/teacherLayout.vue
// module id = null
// module chunks = 